<div
  [style.background-color]="backgroundColor"
  [style.color]="color"
  [class]="'avatar-' + size">
  <ng-content></ng-content>
</div>
